import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isLoading: false,
  isAuth: false,
  userToken: '',
  loginError: "",
  userData: {},
  userBranchStore: {}
};

const loginSlice = createSlice({
  name: "login",
  initialState,
  reducers: {
    loginPending: (state) => {
      state.isLoading = true;
    },
    loginSuccess: (state, { payload }) => {
      state.isLoading = false;
      state.isAuth = true;
      state.userToken = payload.userToken;
      state.userData = payload.userData;
      state.userBranchStore = payload.userBranchStore;
      state.loginError = "";
      localStorage.setItem('userToken', payload.userToken);
    },
    loginFail: (state, { payload }) => {
      state.isLoading = false;
      state.isAuth = false;
      state.userToken = '';
      state.userData = {};
      state.userBranchStore = {};
      state.loginError = payload;
    },
    loginReset: (state) => {
      state.isLoading = false;
      state.isAuth = false;
      state.userToken = '';
      state.userData = {};
      state.userBranchStore = {};
      state.loginError = '';
    },
  },
});

const { reducer, actions } = loginSlice;

export const { loginPending, loginSuccess, loginFail, loginReset } = actions;

export default reducer;